<hlm-dialog-header>
  <h3 hlmDialogTitle>
    {{ cartographie().estVerrouilleeOffreRegionale ? 'Déverrouiller' : 'Verrouiller' }} l'offre régionale
  </h3>
</hlm-dialog-header>

<div class="p-md gap-lg grid">
  @if (!cartographie().estVerrouilleeOffreRegionale) {
    <p>
      Le verrouillage de l’offre régionale est définitive. Les Responsables Formation Régoniaux ne pourront plus ajouter
      d’offres de formations à leur région, et les validateurs ne pourront plus approuver ou rejeter les groupes.
    </p>
    <p>
      Êtes-vous certain de vouloir verrouiller <b> l’Offre Régionale de la {{ cartographie().nom }} </b> ?
    </p>
  } @else {
    <p>
      Le déverrouillage de l’offre régionale permettra aux Responsables Formation Régoniaux d'ajouter des offres de
      formations à leur région, et les validateurs pourront approuver ou rejeter les groupes à nouveau.
    </p>
    <p>
      Êtes-vous certain de vouloir déverrouiller <b> l’Offre Régionale de la {{ cartographie().nom }} </b> ?
    </p>
  }
</div>
<hlm-dialog-footer class="p-md flex w-full justify-between">
  <button brnDialogClose hlmBtn variant="secondary" type="button">Annuler</button>
  <button (click)="close()" hlmBtn type="button">
    Confirmer le {{ cartographie().estVerrouilleeOffreRegionale ? 'déverrouillage' : 'verrouillage' }}
  </button>
</hlm-dialog-footer>
